import React, { useState } from 'react';
import PropTypes from 'prop-types';
import LectureItem from './LectureItem';

export default function Sidebar({ lectures, activeId, onSelect }) {
  const [searchTerm, setSearchTerm] = useState('');

  const filtered = lectures.filter(l =>
    l.title.toLowerCase().includes(searchTerm.toLowerCase())
  );


  return (
    <div className="d-flex flex-column h-100">
      <div style={{ position: 'sticky', top: 0, zIndex: 10, background: '#FBFBFB' }}>
        <div className="px-3 pt-3">
          <div className="input-group">
            <input
              type="text"
              className="form-control rounded-pill shadow-sm"
              placeholder="🔍 Search lectures…"
              value={searchTerm}
              onChange={e => setSearchTerm(e.target.value)}
            />
          </div>
        </div>

        <div className="px-3 pb-2 border-bottom mt-3">
          <h5 className="mb-0"><strong>Course Content</strong></h5>
        </div>
      </div>

      <div style={{ overflowY: 'auto', flexGrow: 1 }}>
        <ul className="list-group list-group-flush">
          {filtered.map((lec, index) => (
            <li
              key={lec.id}
              className="list"
              style={{ cursor: 'pointer' }}
              onClick={() => onSelect(lec.id)}
            >
              <LectureItem
                lecture={lec}
                isActive={lec.id === activeId}
                onSelect={onSelect}
                number={index + 1}
              />
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}

Sidebar.propTypes = {
  lectures: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      title: PropTypes.string,
      category: PropTypes.string,
    })
  ).isRequired,
  activeId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  onSelect: PropTypes.func.isRequired,
};